<app-modal-main class="confirm-modal">
  <app-modal-main-content>
    <app-modal-header [align]="'center'">
      <app-modal-title>{{ 'modals.confirmModal.title' | translate }}</app-modal-title>
      <app-paragraph>
        {{ 'modals.confirmModal.description' | translate: { type: data?.email ? ('modals.confirmModal.email' | translate | lowercase) : ('modals.confirmModal.phoneNumber' | translate | lowercase) } }}
        <br />
        @if (data) {
          <app-strong>{{ data.email ?? data.phoneCode + ' ' + (data.phone | hidePhone) }}</app-strong>
        }
      </app-paragraph>
    </app-modal-header>
    <app-form [formGroup]="form" (submited)="send()">
      <app-grid [gap]="16">
        <app-otp-input [formControlName]="'otp'"></app-otp-input>
        <app-underline-link class="confirm-modal__resend" [color]="'primary'" (clicked)="registerUser()">{{ 'modals.confirmModal.resend' | translate }}</app-underline-link>
      </app-grid>
      <app-button [type]="'submit'" [disabled]="form.invalid" [align]="'center'">{{ 'forms.confirm' | translate }}</app-button>
    </app-form>
  </app-modal-main-content>
</app-modal-main>
